import * as React from "react";
const SvgDownloadCloud02 = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11 12a1 1 0 1 1 2 0v6.586l2.293-2.293a1 1 0 1 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 1 1 1.414-1.414L11 18.586zM1 10.5a8.5 8.5 0 0 1 15.714-4.495 6.499 6.499 0 0 1 3.923 11.509 1 1 0 1 1-1.274-1.542A4.5 4.5 0 0 0 16.5 8a1.62 1.62 0 0 1-1.396-.795 6.5 6.5 0 1 0-10.209 7.883 1 1 0 0 1-1.416 1.411A8.48 8.48 0 0 1 1 10.5"
}));
export default SvgDownloadCloud02;
//# sourceMappingURL=DownloadCloud02.js.map